<template>
    <div class="c-box-1">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
     name:'',

};
</script>

<style scoped lang="scss">
.c-box-1{
height: 100%;
padding: 15px 25px;
overflow: auto;
min-height: 450px;
}
</style>
